import { createFileRoute } from '@tanstack/react-router';
import { VStack, Text, Button } from 'ui_2';
import { useNavigate } from '@tanstack/react-router';
import { Route as index_route } from '@routes/index';
import { useEffect, useState } from 'react';
import { Header } from '@src/components/Header';
import { SECONDS_PER_ROUND } from '@src/data/useGameStore';
import useWindowDimensions from '@puzzlehq/frontend-utils/src/hooks/useWindowDimensions';

export const Route = createFileRoute('/info')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate({ from: Route.id });

  const [infoView, setInfoView] = useState(0);
  const infoTexts = [
    'Earn PART for guessing where you are in the world!',
    `You have ${SECONDS_PER_ROUND} seconds to guess on the mini map`,
    'The closer your guess to the answer, the more PART you win',
  ];

  const [videoReady, setVideoReady] = useState(false);
  useEffect(() => {
    const videoElement = document.getElementById(
      'info-video'
    ) as HTMLVideoElement | null;

    const handleCanPlay = () => {
      setVideoReady(true);
    };

    if (videoElement) {
      videoElement.addEventListener('canplay', handleCanPlay);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('canplay', handleCanPlay);
      }
    };
  }, []);

  const { width } = useWindowDimensions();
  const isMobile = width < 800;

  return (
    <VStack className='relative h-full flex-none'>
      <div className='relative'>
        <video
          id='info-video'
          playsInline
          autoPlay={true}
          loop={true}
          controls={false}
          muted={true}
          src={
            isMobile
              ? 'https://storage.googleapis.com/bucket-quickstart_jigsaw-bigshot/MysteryCity/videos/float_mobile.mp4'
              : 'https://storage.googleapis.com/bucket-quickstart_jigsaw-bigshot/MysteryCity/videos/float_desktop.mp4'
          }
          className='h-[100dvh] w-screen object-cover'
        />
        {!videoReady && (
          <img
            src={
              isMobile
                ? 'https://storage.googleapis.com/bucket-quickstart_jigsaw-bigshot/MysteryCity/images/float_mobile.png'
                : 'https://storage.googleapis.com/bucket-quickstart_jigsaw-bigshot/MysteryCity/images/float_desktop.png'
            }
            alt='Video placeholder'
            className='absolute top-0 h-[100dvh] w-screen object-cover'
          />
        )}
      </div>
      <div>
        <Header showInfo={false} showLogo={true} />
        <VStack className='absolute bottom-10 left-1/2 w-full max-w-[360px] -translate-x-1/2 transform gap-8'>
          <VStack className='text-center'>
            <Text family='space' font='md' className='bg-black text-aqua'>
              {infoView + 1} of 3
            </Text>
            <Text family='space' font='lg' className='bg-black text-aqua'>
              {infoTexts[infoView]}
            </Text>
          </VStack>

          <Button
            variant='mysteryCityPrimary'
            className='relative left-1/2 w-full max-w-[300px] -translate-x-1/2 transform justify-center text-[20px]'
            onClick={() => {
              if (infoView >= 2) {
                navigate({ to: index_route.to });
              } else {
                setInfoView(infoView + 1);
              }
            }}
          >
            {infoView >= 2 ? 'Go home' : 'Next'}
          </Button>
        </VStack>
      </div>
    </VStack>
  );
}
